export const items = [
  {
    name: 'IMG-0124.png',
    downloadUrl: '/download_a',
    viewUrl: '/preview_a',
  },
  {
    name: 'jobsite-visit.pdf',
    downloadUrl: '/download_b',
    viewUrl: '/preview_b',
  },
  {
    name: 'non-previewable-file.exe',
    downloadUrl: '/download_c',
    viewUrl: '',
  },
  {
    name: 'file-with-very-long-name-that-will-wrap-onto-infinite-lines forever-depending-on-viewport-width.png',
    downloadUrl: '/download_d',
    viewUrl: '/preview_d',
  },
  {
    name: 'IMG-2202.heif',
    downloadUrl: '/download_e',
    viewUrl: '/preview_e',
  },
  {
    name: 'AC01-DRAWING-COVER-SHEET.pdf',
    downloadUrl: '/download_f',
    viewUrl: '/preview_f',
  },
  {
    name: 'IMG-01.png',
    downloadUrl: '/download_g',
    viewUrl: '/preview_g',
  },
  { name: 'permit.docx', downloadUrl: '/download_h', viewUrl: '' },
]
